import { Prospect } from './models/prospect.model';
import talentApi from './talent-api-config';

class ProspectApi {
    async sendProspect(prospect: Prospect): Promise<any> {
        return await talentApi.post<any>(`/talent/prospect/`, prospect);
    }
}

export const prospectApi = new ProspectApi();